<template>
    <div v-loading="loading">
        <h3>基本信息</h3>
        <div class="flex">
            <div class="flex_child">姓名：{{formDetail.clientName}}</div>
            <div class="flex_child">性别：{{formDetail.clientSex}}</div>
            <div class="flex_child">年龄：{{formDetail.clientAge}}</div>
        </div>
        <div class="flex">
            <div class="flex_child">联系方式：{{formDetail.clientMobile}}</div>
            <div class="flex_child">床号：{{formDetail.bedNumber}}</div>
            <div class="flex_child">入院日期：{{formDetail.hospitalizedTime}}</div>
        </div>
        <div class="flex">
            <div class="flex_child">入观时间：{{formDetail.entranceTime}}</div>
            <div class="flex_child">出观时间：{{formDetail.exportTime}}</div>
            <div class="flex_child"></div>
        </div>
        <div class="flex">
            <div class="flex_child">手术时间：{{formDetail.operationTime}}</div>
        </div>
        <h3>留观数据</h3>
        <div v-for="item in formDetail.observeList" :key="item.type">
            <div class="observData">
                <span class="flex_child" v-if="item.type==1">体温表</span>
                <span class="flex_child" v-if="item.type==2">护理记录单</span>
                <span class="flex_child" v-if="item.type==3">手术病人护理交接记录</span>
                <span class="flex_child" v-if="item.type==4">长期医嘱单</span>
                <span class="flex_child" v-if="item.type==5">临时医嘱单</span>
                <span class="flex_child">{{item.createTime}}</span>
                <span class="flex_child">{{item.createBy}}</span>
                <span>
                    <el-button size="small" type="warning" @click="exp(item)">导出</el-button>
                    <el-button size="small" type="warning" @click="checkDetail(item)">详情</el-button>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['formDetail'],
    data() {
        return {
            loading: false,
            expData: '',
        }
    },
    methods: {
        exp(row) {
            let exportUrl = axios.defaults.baseURL;
            var formData = new FormData();
            formData.append("id", row.id)
            formData.append("type", row.type)
            this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.loading = true;
                    axios
                        .post(
                            exportUrl + "leaveObserve/wordLeaveObserveDataById", formData, {
                                responseType: "blob",
                            }
                        )
                        .then((res) => {
                            console.log(res)
                            const blob = new Blob([res.data], {
                                type: "application/vnd.msword",
                            });
                            // console.log(blob, '----------0990');
                            const fileName = "导出数据.doc";
                            const linkNode = document.createElement("a");
                            linkNode.download = fileName; //a标签的download属性规定下载文件的名称
                            linkNode.style.display = "none";
                            linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
                            document.body.appendChild(linkNode);
                            linkNode.click(); //模拟在按钮上的一次鼠标单击
                            URL.revokeObjectURL(linkNode.href); // 释放URL 对象
                            document.body.removeChild(linkNode);
                            this.loading = false;
                        }).catch((err) => {
                            _g.toast("error", err);
                        });;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 单条详情
        checkDetail(row) {
            let querys = {
                id: row.id,
                type: row.type,
            }
            api.request('/leaveObserve/findLeaveObserveDataById', querys, (res) => {
                if (res.result == true) {
                    this.$emit("close");
                    let data = res.data
                    data.code = 1
                    this.expData = res.data
                    if (row.type == 3) {
                        data.placement = [
                            {
                                type: '1',
                                name: '',
                                data: '',
                                colour: '',
                            },
                            {
                                type: '2',
                                name: '',
                                data: '',
                                colour: '',
                            },
                            {
                                type: '3',
                                name: '',
                                data: '',
                                colour: '',
                            },
                            {
                                type: '5',
                                name: '',
                                data: '',
                                colour: '',
                            },
                            {
                                type: '4',
                                name: '',
                                data: '',
                                colour: '',
                            },
                        ];
                        data.placement.forEach((item, index) => {
                            data.catheterizationPostoperative.forEach(list => {
                                if (item.type == list.type) {
                                    data.placement[index] = list
                                }
                            });
                        });
                        data.tubes = data.catheterizationPostoperative.map((item) => item.type)
                        data.preoperativeNurseNo = Number(data.preoperativeNurseNo)
                        data.postoperativeNurseNo = Number(data.postoperativeNurseNo)
                        data.psychologicalNursing = data.psychologicalNursing.split(',')
                        router.push({ name: 'hand', params: data })
                    } else if (row.type == 2) {
                        // console.log(data);
                        router.push({ name: 'nursingRecord', params: data })
                    } else if (row.type == 1) {//体温表
                        api.request('/leaveObserve/findTemperatureSheet', { id: row.id }, (res) => {
                            if (res.result == true) {
                                data.tem = res.data
                                router.push({ name: 'temperature', params: data })
                            } else {
                                _g.toast('error', '请求失败')
                            }
                        })
                    } else if (row.type == 4) {//长期医嘱单
                        router.push({ name: 'orderSheet', params: data })
                    } else if (row.type == 5) {//临时医嘱单
                        router.push({ name: 'sheetForm', params: data })
                    }

                } else {
                    _g.toast("error", res.errMsg);
                }
                // this.formDetail = res.data
                // console.log(this.formDetail);
                // this.formList.timeSlot = this.formList.operationTime
            }, (err) => { })
        },

    }
}
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: space-around;
}
.flex_child {
  flex: 1;
}
.observData {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border: 1px solid #000000; */
  border-radius: 4px;
  margin-bottom: 10px;
  background: #eee;
}
</style>


